/** Shared TAAS brand tokens — sourced from index.css primary palette. */

export const TAAS_GOLD = "light-dark(var(--primary-700), var(--primary-500))";
export const TAAS_GOLD_LIGHT = "light-dark(var(--primary-600), var(--primary-600))";
export const TAAS_GOLD_DIM = "light-dark(var(--primary-900), var(--primary-400))";
export const TAAS_GOLD_LABEL = "light-dark(var(--primary-700), #9fc1a8)";
export const TAAS_CARD_BLACK = "light-dark(var(--primary-100), #0a0a0a)";
export const TAAS_PAGE_BLACK = "light-dark(var(--primary-100-light), #000)";
export const TAAS_SERIF = '"Playfair Display", Georgia, "Times New Roman", serif';
export const TAAS_SANS = "var(--primary-font-family)";

/** Theme-aware alpha — replaces legacy `${color}88` hex suffix on CSS vars. */
export function taasWithAlpha(color: string, hexAlpha: string): string {
  const pct = Math.round((Number.parseInt(hexAlpha, 16) / 255) * 100);
  return `color-mix(in srgb, ${color} ${pct}%, transparent)`;
}

/**
 * Foil text — high-contrast gradients visible on short labels and large headlines.
 *
 * Retains the legacy export name so existing call sites keep working, but the
 * gradient now follows the thehope.one forest → green → sage language.
 */
export const taasGoldFoil = {
  color: "var(--text)",
  WebkitTextFillColor: "unset",
  background: "none",
} as const;

export const taasPrimaryButtonSx = {
  background: "var(--button-gradient)",
  color: "var(--primary-1000)",
  fontWeight: 700,
  fontFamily: TAAS_SANS,
  textTransform: "none" as const,
  boxShadow: "var(--shadow-sm)",
  "&:hover": {
    background: "var(--button-gradient-hover)",
    boxShadow: "var(--shadow-md)",
  },
  "&:disabled": {
    opacity: 0.55,
    color: "var(--primary-1000)",
  },
};
